import { render, staticRenderFns } from "./InfoAboutInsurance.vue?vue&type=template&id=0f4f4c42&scoped=true"
import script from "./InfoAboutInsurance.vue?vue&type=script&lang=js"
export * from "./InfoAboutInsurance.vue?vue&type=script&lang=js"
import style0 from "./InfoAboutInsurance.vue?vue&type=style&index=0&id=0f4f4c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f4c42",
  null
  
)

export default component.exports